"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgMstv(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("rect", { x: 3, y: 14, width: 34, height: 12, rx: 1.8, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M22 23a3 3 0 100-6 3 3 0 000 6zM8 21a1 1 0 100-2 1 1 0 000 2zM11 21a1 1 0 100-2 1 1 0 000 2zM14 21a1 1 0 100-2 1 1 0 000 2zM33 19v2-2z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M33 19v2", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgMstv;
//# sourceMappingURL=Mstv.js.map